import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { OrderConfirmation } from '@amzn/burberry-ui-components';
import { awsRum } from 'src/rum';
import { AppDispatch } from 'src/store/store';
import { replaceCartState } from 'src/store/cartSlice';
import { Paths } from 'src/paths/Paths';
import { metricEmitter } from 'src/utils/metricEmitter';
import {
  YOUR_ORDER_CONFIRMED_STRING,
  ORDER_STATUS_INSTRUCTION_STRING,
  TAKE_ME_TO_ORDERS_STRING,
  CONTINUE_SHOPPING_STRING,
} from '@amzn/d2c-application-website-common';
import './Success.scss';

const PAGE_NAME = 'Success';

const isValidOrderStatusUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return parsed.hostname.endsWith('.amazon.com');
  } catch {
    return false;
  }
};

const Success: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const confirmOrderComplete = searchParams.get('confirmOrderComplete') || '';
  const orderStatusUrl = isValidOrderStatusUrl(confirmOrderComplete) ? confirmOrderComplete : '';

  useEffect(() => {
    if (!confirmOrderComplete) {
      navigate(Paths.home, { replace: true });
      return;
    }
    awsRum?.recordEvent('PageView', { page: PAGE_NAME });
    dispatch(replaceCartState({
      cart: null,
      previewOrderInProgress: false,
      confirmOrderInProgress: false,
    } as any));
  }, []);

  const handleContinueShopping = () => {
    navigate(Paths.home);
  };

  if (!confirmOrderComplete) {
    return null;
  }

  return (
    <div className="success-page" data-testid="success-page">
      <OrderConfirmation
        heading={YOUR_ORDER_CONFIRMED_STRING}
        message={ORDER_STATUS_INSTRUCTION_STRING}
        orderStatusUrl={orderStatusUrl}
        orderStatusLinkText={TAKE_ME_TO_ORDERS_STRING}
        buttonText={CONTINUE_SHOPPING_STRING}
        onButtonClick={handleContinueShopping}
        metricEmitter={metricEmitter}
      />
    </div>
  );
};

export default Success;
